import TemplateGlobal from '@src/components/Layout/TemplateGlobal'
import SelectedCompanyProvider from '@src/providers/SelectedCompanyProvider'
import type { JSX } from 'react'
import { createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider } from 'react-router-dom'
import DocsAutomationListPage from './DocsAutomation'
import ClassificationReport from './Reports'
import ViewDocument from './ViewDocument'

// https://reactrouter.com/6.30.1/routers/picking-a-router
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route element={<SelectedCompanyProvider />}>
        <Route element={<TemplateGlobal />}>
          <Route path="/reports/classification" element={<ClassificationReport />} />
          <Route path="/documents/:id/*" element={<ViewDocument />} />
          <Route path="*" element={<DocsAutomationListPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>,
  ),
)

const Router = (): JSX.Element => {
  return <RouterProvider router={router} />
}

export default Router
